const ZIP_CODE_FETCHING = {
    input: { name: 'Input', id: 'input' },
    parameters: { name: 'Parameters', id: 'parameters' },
}

export { ZIP_CODE_FETCHING }
